module.exports = __webpack_public_path__ + "img/textnice@2x.7d11aa96.png";